<div
  class="filters-container"
  *ngIf="
    (showPaymentMethodSelector && showRefundableRateSwitch) ||
    showPaymentMethodSelector ||
    showRefundableRateSwitch
  "
>
  <payment-method-selector
    *ngIf="showPaymentMethodSelector"
    (paymentMethodChange)="changePaymentMethod($event)"
    [selectedPaymentMethod]="selectedPaymentMethod"
    [countryId]="hotelAvailabilityInfo.country.id"
  ></payment-method-selector>
  <div
    class="divider"
    *ngIf="showPaymentMethodSelector && showRefundableRateSwitch"
  ></div>
  <refundable-rate
    *ngIf="showRefundableRateSwitch"
    (refundableRateChange)="changeRefundableRate($event)"
    [refundableRateSelected]="refundableRateSelected"
  ></refundable-rate>
</div>
<ng-container *ngIf="openChangedPricesAlert?.value">
  <alert-content
    [showAlert]="openChangedPricesAlert"
    mobile="true"
    [title]="openChangedPricesAlert.type"
    [imageName]="
      openChangedPricesAlert.type === 'CHEAPER'
        ? brand + '-wallet.svg'
        : brand + '-card.svg'
    "
  ></alert-content>
</ng-container>
<ng-container *ngIf="openPaymentsMethodsAlert?.value">
  <alert-content
    [showAlert]="openPaymentsMethodsAlert"
    mobile="true"
    [title]="openPaymentsMethodsAlert.type"
    imageName="payments-options-alert.svg"
  ></alert-content>
</ng-container>
<ng-container *ngIf="openRefundableRateAlert?.value">
  <alert-content
    [showAlert]="openRefundableRateAlert"
    mobile="true"
    [title]="openRefundableRateAlert.type"
    imageName="cancel-rates-alert.svg"
  ></alert-content>
</ng-container>
